import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Collapse from "@material-ui/core/Collapse";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Alert from "@material-ui/lab/Alert";
import { formatBytes } from "../functions";
import ImageLoader from "./ImageLoader";

const COMPRESSION_LEVEL = process.env.REACT_APP_FILEUPLOADER_COMPRESSION
  ? process.env.REACT_APP_FILEUPLOADER_COMPRESSION
  : 0.8;

export const resizeImage = (img, callback) => {
  const reader = new FileReader();
  reader.onload = e => {
    const img = document.createElement("img");
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let imgInitX = 0;
      let imgInitY = 0;
      let imgEndX = 0;
      let imgEndY = 0;

      if (img.height < img.width) {
        //horizontal
        const height = img.height;
        canvas.height = height;
        canvas.width = height;

        imgInitY = (img.height - height) / 2;
        imgEndY = height;
        imgInitX = (img.width - height) / 2;
        imgEndX = height;
      } else {
        //vertical
        const width = img.width;
        canvas.height = width;
        canvas.width = width;

        imgInitX = (img.width - width) / 2;
        imgEndX = width;
        imgInitY = (img.height - width) / 2;
        imgEndY = width;
      }

      ctx.drawImage(
        img,
        imgInitX, ///sx
        imgInitY, //sy
        imgEndX, //sw
        imgEndY, //sh
        0, //dx
        0, //dy
        canvas.width, //dw
        canvas.height // dh
      );

      canvas.toBlob(callback, "image/jpeg", parseFloat(COMPRESSION_LEVEL));
    };
    img.src = e.target.result;
  };
  reader.readAsDataURL(img);
};

const FileUploader = ({ parent, className, data, onAdd, onEdit, onRemove, maxFiles = 5 }) => {
  const [inDropZone, setInDropZone] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState("");
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleDragEnter = e => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(true);
  };
  const handleDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(false);
  };
  const handleDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(true);
  };
  const handleDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    setInDropZone(false);

    let files = [...e.dataTransfer.files];

    if (files && files.length > 0) {
      handleAdd(files);
    }
  };

  const handleAdd = newFiles => {
    if (onAdd) {
      setAlertOpen(false);
      newFiles = Array.from(newFiles);

      if (data.length + newFiles.length <= maxFiles) {
        for (let index = 0; index < newFiles.length; index++) {
          const currentFile = newFiles[index];
          const type = "image/jpeg";
          const extension = ".jpeg";
          const name = currentFile.name.split(".")[0];

          resizeImage(currentFile, blob => {
            const newFile = {
              name,
              extension,
              type,
              blob,
              url: URL.createObjectURL(blob),
              size: formatBytes(blob.size)
            };

            if (previewOpen && previewFile) {
              onRemove(previewFile);
              setPreviewOpen(false);
            }
            onAdd(newFile);
          });
        }
      } else {
        setAlertMsg("No se pueden agregar mas de " + maxFiles + " archivos");
        setAlertOpen(true);
      }
    }
  };

  const handleEdit = newFiles => {
    if (onEdit) {
      newFiles = Array.from(newFiles);

      if (newFiles.length > 0) {
        const currentFile = newFiles[0];
        const type = "image/jpeg";
        const extension = ".jpeg";
        const name = currentFile.name.split(".")[0];

        resizeImage(currentFile, blob => {
          const newFile = {
            name,
            extension,
            type,
            blob,
            url: URL.createObjectURL(blob),
            size: formatBytes(blob.size)
          };

          onEdit(previewFile, newFile);
          setPreviewFile(previewFile);
          setPreviewOpen(false);
        });
      }
    }
  };

  const handlePreviewOpen = f => {
    setAlertOpen(false);
    setPreviewFile(f);
    setPreviewOpen(true);
  };

  const handlePreviewClose = e => {
    setPreviewOpen(false);
  };

  const handlePreviewDelete = e => {
    setPreviewOpen(false);
    if (onRemove) onRemove(previewFile);
  };

  const renderMainMedia = () => {
    if (data && data.length > 0) {
      const file = data[0];
      let imgComp = "";

      if (file.url) imgComp = <img src={file.url} alt="main-img" />;
      else
        imgComp = (
          <ImageLoader imgKey={file.key} alt="main-img" className="file-uploader-loader-main" />
        );
      return (
        <Card className="main-card">
          <CardActionArea onClick={e => handlePreviewOpen(file)}>
            <CardMedia>{imgComp}</CardMedia>
          </CardActionArea>
        </Card>
      );
    } else {
      return (
        <label htmlFor={"upload-" + parent}>
          <div
            className={inDropZone ? "upload-container inside-drag-area" : "upload-container"}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
          >
            <IconButton component="span">
              <AddAPhotoIcon fontSize="large" />
            </IconButton>
            <Typography className="ml-2 mr-2" variant="body1" align="center">
              {isMobile
                ? "Haga click para subir una imagen de tu producto"
                : "Haga click o arrastrar y soltar para subir imagenes de tu producto"}
            </Typography>
          </div>
        </label>
      );
    }
  };

  const renderMediaList = () => {
    let showAddButton = false;

    if (data && data.length > 0 && data.length < maxFiles) showAddButton = true;

    return (
      <div className="list-container">
        {data.map(
          (f, i) =>
            i > 0 && (
              <Card key={`file-${i}`} className="media-card">
                <CardActionArea onClick={e => handlePreviewOpen(f)}>
                  <CardContent>
                    {f.url ? (
                      <img src={f.url} alt={`file-img-${i}`} />
                    ) : (
                      <ImageLoader
                        imgKey={f.key}
                        alt={`file-img-${i}`}
                        className="file-uploader-loader-secondary"
                      />
                    )}
                  </CardContent>
                </CardActionArea>
              </Card>
            )
        )}
        {showAddButton && renderMainButton()}
      </div>
    );
  };

  const renderMainButton = () => {
    return (
      <Card className="add-card">
        <CardContent>
          <label htmlFor={"upload-" + parent}>
            <IconButton component="span">
              <AddAPhotoIcon fontSize="large" />
            </IconButton>
          </label>
        </CardContent>
      </Card>
    );
  };

  const renderHelp = () => {
    return (
      <Dialog
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Tip foto de producto"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Toma distancia para fotografiar tu producto. Debe aparecer centrado en tu cámara.
            <br />
            Así podrás exhibir de mejor forma en tu carrito de venta! &#128521;
          </DialogContentText>
          <img
            className="w-100"
            src={process.env.PUBLIC_URL + "/assets/images/help-img.png"}
            alt="help-img"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setHelpOpen(false)} color="primary" autoFocus>
            De acuerdo!
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderPreview = () => {
    let imgComponent = "";

    if (previewFile && previewFile.url) {
      imgComponent = <img src={previewFile.url} alt="product-preview" />;
    } else if (previewFile && previewFile.key) {
      imgComponent = (
        <ImageLoader className="w-100" imgKey={previewFile.key} alt="product-preview" />
      );
    }

    return (
      <Dialog
        className="media-preview"
        open={previewOpen}
        onClose={handlePreviewClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle disableTypography className="media-preview-title">
          <IconButton aria-label="close" onClick={handlePreviewClose}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </DialogTitle>
        <DialogContent>{imgComponent}</DialogContent>
        <DialogActions disableSpacing className="media-preview-actions">
          <label>
            <Button
              size="large"
              startIcon={<DeleteIcon fontSize="large" />}
              onClick={handlePreviewDelete}
            >
              Eliminar imagen
            </Button>
          </label>
          <label htmlFor={"upload-edit-" + parent}>
            <Button size="large" component="span" endIcon={<EditIcon fontSize="large" />}>
              Cambiar imagen
            </Button>
          </label>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <div className={className}>
      <div className="main-container">
        <div className="main-subcontainer">
          <div className="help-container">
            <Alert variant="outlined" severity="info">
              Hay algo que debes saber!{" "}
              <Link component="button" onClick={() => setHelpOpen(true)}>
                Haz click aqui!
              </Link>
            </Alert>
          </div>

          {renderMainMedia()}

          <Collapse in={alertOpen}>
            <Alert
              className="mt-2"
              severity="warning"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setAlertOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {alertMsg}
            </Alert>
          </Collapse>
        </div>

        <div className="secondary-subcontainer">{renderMediaList()}</div>

        <input
          accept="image/*"
          multiple
          style={{ display: "none" }}
          id={"upload-" + parent}
          type="file"
          onChange={({ target }) => handleAdd(target.files)}
        />
        <input
          accept="image/*"
          style={{ display: "none" }}
          id={"upload-edit-" + parent}
          type="file"
          onChange={({ target }) => handleEdit(target.files)}
        />

        {renderHelp()}
        {renderPreview()}
      </div>
    </div>
  );
};

export default FileUploader;
